import { atom, WritableAtom } from 'jotai';
import {
  getOrgPreferenceKey,
  PreferenceKey,
  PreferenceScope,
} from '../../data-models/preferences-v3.data-model';
import { CurrencyCode } from '../../util/currency-util';
import { preferenceAtom } from '../../util/preferences-service-v3';
import { defaultCurrency } from './AppConfigStateJ';

type AppCurrency = { currency: CurrencyCode };
export const selectedCurrencyPrefAtom = preferenceAtom<AppCurrency>(
  [
    { scope: PreferenceScope.USER, preferenceKey: PreferenceKey.appCurrency },
    {
      scope: PreferenceScope.ORGANIZATION,
      preferenceKey: getOrgPreferenceKey(PreferenceKey.appCurrency, null),
    },
  ],
  { scope: PreferenceScope.USER, preferenceKey: PreferenceKey.appCurrency },
  { currency: defaultCurrency }
) as WritableAtom<AppCurrency, [newValue: AppCurrency], void>;

export const currentCurrencyCodeAtom = atom(defaultCurrency);
